import React from 'react';
import { companyInfo } from '../../data/mockData';

const Hero = () => {
  return (
    <section className="relative min-h-screen flex flex-col justify-center overflow-hidden bg-[#f8f7f4]">
      {/* Gradient blob background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div
          className="absolute top-0 right-0 w-[80%] h-[120%] opacity-70"
          style={{
            background: `
              radial-gradient(ellipse 80% 60% at 70% 20%, rgba(255, 220, 180, 0.6) 0%, transparent 50%),
              radial-gradient(ellipse 60% 50% at 80% 50%, rgba(180, 230, 255, 0.6) 0%, transparent 50%),
              radial-gradient(ellipse 50% 60% at 60% 70%, rgba(220, 180, 255, 0.5) 0%, transparent 50%),
              radial-gradient(ellipse 40% 40% at 90% 80%, rgba(255, 150, 220, 0.4) 0%, transparent 50%)
            `,
            filter: 'blur(40px)',
            transform: 'rotate(-10deg)'
          }}
        />
      </div>

      {/* Content */}
      <div className="relative z-10 px-6 md:px-12 lg:px-24 pt-32 pb-16">
        {/* Main headline */}
        <div className="max-w-7xl">
          <h1 className="text-[clamp(3rem,12vw,12rem)] font-light leading-[0.9] tracking-tight text-black">
            <span className="block">fuel</span>
            <span className="block ml-[5%] md:ml-[10%]">your</span>
            <span className="block ml-[2%] md:ml-[5%]">
              gr
              <span className="inline-block w-[0.5em] h-[0.5em] rounded-full bg-gradient-to-br from-cyan-400 via-purple-400 to-pink-400 mx-1 align-middle animate-pulse" />
              wth
            </span>
          </h1>
        </div>

        {/* Subtext */}
        <div className="mt-12 md:mt-16 max-w-xl ml-auto mr-0 md:mr-24">
          <p className="text-lg md:text-xl text-gray-800 leading-relaxed">
            {companyInfo.description} <span className="font-semibold">Let us help you hyper grow.</span>
          </p>
        </div>

        {/* Award badges */}
        <div className="mt-16 flex flex-wrap items-center gap-8 opacity-60">
          <div className="flex items-center gap-2">
            <div className="w-10 h-10 rounded-full border border-gray-400 flex items-center justify-center text-xs font-bold">DR</div>
            <span className="text-xs uppercase tracking-wider text-gray-600">Design Rush<br/>Verified</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-10 h-10 rounded-full border border-gray-400 flex items-center justify-center text-xs font-bold">★</div>
            <span className="text-xs uppercase tracking-wider text-gray-600">Award<br/>Winner</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-10 h-10 rounded-full border border-gray-400 flex items-center justify-center text-xs font-bold">FB</div>
            <span className="text-xs uppercase tracking-wider text-gray-600">Fox Business<br/>Featured</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-10 h-10 rounded-full border border-gray-400 flex items-center justify-center text-xs font-bold">PA</div>
            <span className="text-xs uppercase tracking-wider text-gray-600">Patriot<br/>Award</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
